import { SunOutlined, MoonOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { TRANSITIONS } from '@/shared/constants/transitions'
import { RootState } from '@/store'
import { toggleTheme } from '@/store/slices/themeSlice'

/**
 * ThemeToggle Component
 * 
 * Toggle button to switch between light and dark themes
 */
export const ThemeToggle: React.FC = () => {
  const dispatch = useDispatch()
  const themeMode = useSelector((state: RootState) => state.theme.mode)
  const isDark = themeMode === 'dark'

  const handleToggle = () => {
    dispatch(toggleTheme())
  }

  return (
    <Button
      type="text"
      icon={isDark ? <SunOutlined style={{ fontSize: 20 }} /> : <MoonOutlined style={{ fontSize: 20 }} />}
      onClick={handleToggle}
      shape="circle"
      size="large"
      style={{
        color: isDark ? '#C1D4D9' : '#5E6B70',
        transition: TRANSITIONS.FAST,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onMouseEnter={(e) => {
        const target = e.currentTarget as HTMLElement
        target.style.color = isDark ? '#04BFAD' : '#009C92'
        target.style.backgroundColor = isDark ? 'rgba(4, 191, 173, 0.1)' : 'rgba(0, 156, 146, 0.1)'
      }}
      onMouseLeave={(e) => {
        const target = e.currentTarget as HTMLElement
        target.style.color = isDark ? '#C1D4D9' : '#5E6B70'
        target.style.backgroundColor = 'transparent'
      }}
      aria-label={isDark ? 'Chuyển sang chế độ sáng' : 'Chuyển sang chế độ tối'}
      title={isDark ? 'Chế độ sáng' : 'Chế độ tối'}
    />
  )
}

export default ThemeToggle
